import { render, staticRenderFns } from "./GBankCreate.vue?vue&type=template&id=7b7e9cde&lang=pug&"
import script from "./GBankCreate.vue?vue&type=script&lang=js&"
export * from "./GBankCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GBankCreate.vue"
export default component.exports